import { type Choice } from 'inkjs/engine/Choice';

export const parseTags = (tags: string[] | null, text: string, choices: Choice[]) => {
  const chainNextLine = (!!tags?.some((tag) => tag === 'chain_next') && choices.length === 0) || text === '\n';

  const skipSave = !!tags?.some((tag) => tag === 'skip_save');

  const skipTyping = !!tags?.some((tag) => tag === 'skip_typing');

  const isSilent = !!tags?.some((tag) => tag === 'silent');

  const pace = +(
    tags
      ?.filter((tag) => tag.includes('pace:'))?.[0]
      ?.split('pace:')?.[1]
      .trim() || 50
  );

  const classes = tags?.filter((tag) => tag.includes('classes:'))?.[0]?.split('classes:')?.[1] || '';

  const speaker =
    tags
      ?.filter((tag) => tag.includes('speaker:'))?.[0]
      ?.split('speaker:')?.[1]
      .trim() || '';

  const event =
    tags
      ?.filter((tag) => tag.includes('event:'))?.[0]
      ?.split('event:')?.[1]
      .trim() || '';

  const events =
    tags
      ?.filter((tag) => tag.includes('events:'))?.[0]
      ?.split('events:')?.[1]
      .trim()
      .split(',') || [];

  const wait = +(
    tags
      ?.filter((tag) => tag.includes('wait:'))?.[0]
      ?.split('wait:')?.[1]
      .trim() || 10
  );

  return {
    chainNextLine,
    pace,
    speaker,
    classes,
    skipSave,
    skipTyping,
    isSilent,
    event,
    events,
    wait,
  };
};
